/**
 * Builds the `/products` query params for a listing page.
 *
 * Extracted so the SERVER prefetch and the CLIENT hook derive their params — and
 * therefore their react-query cache key — from the exact same code. If the two
 * ever drifted, the dehydrated entry would not match the key the client asks
 * for: the SSR markup would be discarded and refetched on hydration (and, worse,
 * could surface as a hydration mismatch).
 *
 * Note `limit: 24` is part of the key, so it must stay identical on both sides.
 */
export const productQuery = (
  query: Record<string, unknown>,
  category_id?: number | string,
): Record<string, unknown> => {
  const params: Record<string, unknown> = {
    ...query,
    limit: 24,
  };
  if (category_id) params["category_id"] = category_id;
  return params;
};

export default productQuery;
